import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { PAGINATED_APP_GRID_CONFIG, usePaginatedAppGrid } from '@atlassian/mpac-app-tile';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { GetMarketplaceSearch } from '@atlassian/mpac-services-client';
import { useLocation, useQueryParams } from '@atlassian/mpac-ui';
import { isServerSide, useEnvironment } from '@atlassian/mpac-utils';
import { useEffect } from 'react';
import { ANALYTICS } from '../../constants';
import { defaultFilterDefinitions } from '../utils/filters/searchPageFiltersConfig';
import { useSearchPageAnalytics } from './useSearchPageAnalytics';
// This is a temporary change for testing purposes.
function shouldEnableNlpSearch(flag, source) {
  return flag || source === 'enablenlp';
}
export const useSearchResults = function useSearchResults(searchQuery, commitSelectedOptions, skip, sortKey, showPageError, additionalFilters) {
  let filterDefinitions = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : defaultFilterDefinitions;
  const {
    handleTilesRenderedAnalytics,
    handleErrorStateAnalytics
  } = useSearchPageAnalytics();
  const environment = useEnvironment();
  const {
    enableNlpSearch,
    enableMpacSsrSearch
  } = useStatsig();
  const {
    source
  } = useQueryParams();
  const {
    search
  } = useLocation();
  const enableNLPSearchFlag = enableNlpSearch({
    fireExperimentExposure: true
  });
  const isSsrSearchEnabled = enableMpacSsrSearch();
  const renderedOnServer = isSsrSearchEnabled && isServerSide();
  const queryParams = new URLSearchParams(search);
  const sortFromURL = queryParams.get('sort') || '';

  // For aether we need to make request to search v2 index, hence the hardcoding 'true' is done here.
  const gridProps = usePaginatedAppGrid({
    query: GetMarketplaceSearch,
    queryOptions: {
      variables: {
        query: searchQuery,
        filters: commitSelectedOptions,
        sort: renderedOnServer ? sortFromURL : sortKey,
        after: 0,
        first: PAGINATED_APP_GRID_CONFIG.initialFetchCount,
        additionalFilters,
        enableNLPSearch: shouldEnableNlpSearch(enableNLPSearchFlag, source),
        environment,
        filterIds: filterDefinitions.map(filter => filter.filterId),
        search
      },
      skip: renderedOnServer ? false : skip
    },
    parseResponse: data => {
      var _data$marketplaceSear, _data$marketplaceSear2, _data$marketplaceSear3, _data$marketplaceSear4;
      return {
        appList: (data === null || data === void 0 ? void 0 : (_data$marketplaceSear = data.marketplaceSearch) === null || _data$marketplaceSear === void 0 ? void 0 : (_data$marketplaceSear2 = _data$marketplaceSear.edges) === null || _data$marketplaceSear2 === void 0 ? void 0 : _data$marketplaceSear2.map(edge => edge.node)) || [],
        hasNextPage: Boolean(data === null || data === void 0 ? void 0 : (_data$marketplaceSear3 = data.marketplaceSearch) === null || _data$marketplaceSear3 === void 0 ? void 0 : _data$marketplaceSear3.pageInfo.hasNextPage),
        totalCount: (data === null || data === void 0 ? void 0 : (_data$marketplaceSear4 = data.marketplaceSearch) === null || _data$marketplaceSear4 === void 0 ? void 0 : _data$marketplaceSear4.pageInfo.totalCount) || 0
      };
    }
  });
  const {
    appList,
    isLoading,
    isLoadingMore,
    initialFetchError,
    fetchMoreError,
    rawData
  } = gridProps;
  const analyticsFilters = _objectSpread(_objectSpread(_objectSpread({}, searchQuery ? {
    query: searchQuery
  } : {}), sortKey ? {
    sort: sortKey
  } : {}), commitSelectedOptions !== null && commitSelectedOptions !== void 0 ? commitSelectedOptions : {});
  useEffect(() => {
    // HANDLE ANALYTICS
    if (rawData && !showPageError && !isLoading && !isLoadingMore && !initialFetchError && !fetchMoreError) {
      handleTilesRenderedAnalytics({
        filters: analyticsFilters,
        count: appList.length
      });
    }
  }, [rawData, isLoadingMore]);
  useEffect(() => {
    // HANDLE ANALYTICS
    if (!showPageError && (initialFetchError || fetchMoreError)) {
      handleErrorStateAnalytics({
        actionSubjectId: 'AppTileGridErrorRendered',
        errorType: initialFetchError ? ANALYTICS.INITIAL : ANALYTICS.LOAD_MORE
      });
    }
  }, [initialFetchError, fetchMoreError]);
  return {
    gridProps,
    analyticsFilters
  };
};